// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 214) return "static/chunks/214-845846ebbcd86d48.js";
	if (chunkId === 443) return "static/chunks/443-5a449e8e9803ac2b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"722":"0631969b529ad7ff","945":"726f7c86133421e9"}[chunkId] + ".js";
};